"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OSMLayer = void 0;
const Tile_1 = __importDefault(require("ol/layer/Tile"));
const OSM_1 = __importDefault(require("ol/source/OSM"));
const react_1 = require("react");
const useOLMap_1 = require("../../openlayers/useOLMap");
function OSMLayer({ visible = true, zIndex = 0 }) {
    const map = useOLMap_1.useOLMap();
    const layer = react_1.useMemo(() => {
        const layer = new Tile_1.default({ source: new OSM_1.default(), visible, zIndex });
        return layer;
    }, [visible, zIndex]);
    react_1.useEffect(() => {
        map.addLayer(layer);
        return () => {
            map.removeLayer(layer);
        };
    }, [map, layer]);
    return null;
}
exports.OSMLayer = OSMLayer;
//# sourceMappingURL=index.js.map